


<ng-container *ngIf="resultsObserable | async as results; else loading;">
  <ngx-charts-pie-chart *ngIf="results && results.length > 0"
                        style="padding:1px"
                        [view]="view | async"
                        [scheme]="scheme"
                        [results]="results"
                        [gradient]="gradient"
                        [legend]="legend"
                        [legendPosition]="legendPosition"
                        [legendTitle]="legendTitle"
                        [labels]="labels"
                        [doughnut]="true"
                        [trimLabels]="false"
                        (select)="onSelect($event, results)"
                        (activate)="onActivate($event)"
                        (deactivate)="onDeactivate($event)">
    <ng-template *ngIf="eveTooltipTemplate != null" #tooltipTemplate let-model="model">
      <ng-container *ngTemplateOutlet="eveTooltipTemplate;context:{model}"></ng-container>
    </ng-template>
  </ngx-charts-pie-chart>

  <div [innerHTML]="legendStyles | async">
  </div>

  <ng-container *ngIf="results != null && results.length == 0">
    <div style="margin-top: 135px;">
      <div style="opacity: 0.2; color:gray;"><img src="{{reportingUrl}}/Images/eveLogo.png" alt="eve Logo" /></div>
      <div style="color: #646965; text-align: center">no results found</div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <span class="fa fa-spinner fa-pulse fa-5x" style="opacity: 1; color:gray;"></span>
</ng-template>




